
import apiClient from './api';
/**
 * Récupère la liste des CorporateAction pour un domaine donné.
 * @param {number} domainId 
 * @returns {Promise}
 */
export const getCorporateActionStatus = (domainId) =>
  apiClient.get(`api/CorporateAction/GetCoporateActionsByStatut/${domainId}`); 

/**
 * Récupère le compteur des paiements d'intérêts pour un domaine donné.
 * @param {number} domainId 
 * @returns {Promise}
 */
export const getCountInterest = (domainId) =>
  apiClient.get(`api/CorporateAction/CountInterest/${domainId}`);

/**
 * Récupère le compteur des dividendes pour un domaine donné.
 * @param {number} domainId 
 * @returns {Promise}
 */
export const getCountDividends = (domainId) =>
  apiClient.get(`api/CorporateAction/CountDividends/${domainId}`);

/**
 * Récupère le compteur de remboursement de capital pour un domaine donné.
 * (Vérifier l'orthographe de l'endpoint si nécessaire)
 * @param {number} domainId 
 * @returns {Promise}
 */
export const getCountCapitalRepayment = (domainId) =>
  apiClient.get(`api/CorporateAction/CountCapitalRepayement/${domainId}`);

/**
 * Récupère la liste de toutes les securities.
 * @returns {Promise}
 */
export const getSecurities = () =>
  apiClient.get(`api/Security/all`);

/**
 * Crée une nouvelle CorporateAction (événement).
 * @param {Object} eventData 
 * @returns {Promise}
 */
export const createEvent= (eventData) =>
    apiClient.post(`api/CorporateAction`,eventData);


/**
 * Valide un événement.
 * @param {number} id 
 */
export const validateEvent = (id) =>
  apiClient.put(
    `api/CorporateAction/Validate/${id}`,
    {},
    { headers: { "Content-Type": "application/json" } }
  );
  
/**
 * Annule un événement.
 * @param {number} id 
  * @returns {Promise}
 */
export const cancelEvent = async (id) => {
  // Vérifier que l'identifiant est défini et valide
  if (!id) {
    return Promise.reject(new Error("L'ID de l'événement est indéfini"));
  }

  const url = `api/CorporateAction/cancel/${id}`;

  try {
    const response = await apiClient.put(url, {}, { headers: { "Content-Type": "application/json" } });
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de l'annulation de l'événement :", error.response || error.message);
    throw error("Erreur lors de l'annulation de l'événement :", error.response || error.message);
  }
};

export const updateEvent = async (eventId, eventData) => { 
  try {
    const response = await apiClient.put(`/api/CorporateAction/${eventId}`, eventData);
    return response.data; // On suppose que l'API retourne l'événement mis à jour
  } catch (error) {
    throw error.response?.data?.message || "Une erreur s'est produite lors de la mise à jour de l'événement.";
  }
};


  
 /**
 * Récupère les détails d'un événement pour un eventId donné.
 * @param {number|string} eventId - L'identifiant de l'événement.
 * @returns {Promise} La promesse contenant les détails de l'événement.
 */
export const getEventDetails = (eventId) => {
  return apiClient.get(`api/CorporateAction/byId/${eventId}`);
};

/**
 * Récupère les dividendes pour un domaine donné.
 * @param {number} domainId
 * @returns {Promise}
 */
export const getDividends = (domainId) =>
  apiClient.get(`api/CorporateAction/GetDividend/${domainId}`);

/**
 * Récupère les remboursements de capital pour un domaine donné.
 * @param {number} domainId
 * @returns {Promise}
 */
export const getCapitalRepayments = (domainId) =>
  apiClient.get(`api/CorporateAction/GetCapitalRepayment/${domainId}`);

/**
 * Récupère les intérêts pour un domaine donné.
 * @param {number} domainId
 * @returns {Promise}
 */
export const getInterests = (domainId) =>
  apiClient.get(`api/CorporateAction/GetInterest/${domainId}`);
/**
 * Process une Corporate Action spécifique pour le domaine donné.
 * @param {number} eventId - L'ID de l'événement à traiter.
 * @param {number} domainId - Le domaine concerné.
 * @returns {Promise<boolean>}
 */

export const deleteEvent = async (id) => {
  try {
    const response = await apiClient.delete(`/api/CorporateAction/${id}`);
    // On vérifie que le status HTTP est OK
    if (response.status === 200) {
      return true;
    } else {
      throw new Error("La suppression n'a pas pu être effectuée.");
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      "Une erreur est survenue lors de la suppression de l'événement.";
    throw new Error(errorMessage);
  }
};

/**
 * Traite une Corporate Action avec paramètre impot optionnel
 * @param {number} corporateActionId - ID de la corporate action
 * @param {number|null} impot - Montant de l'impôt (optionnel)
 * @returns {Promise<boolean>} - Succès ou échec de l'opération
 */
export const processCorporateAction = async (corporateActionId, impot = null) => {
  try {
    // Construction des paramètres de requête
    const params = new URLSearchParams();
    
    // Ajout du paramètre impot seulement s'il est fourni et non null
    if (impot !== null && impot !== undefined) {
      params.append('impot', impot.toString());
    }

    const url = `/api/CorporateAction/ProcessCorporateAction/${corporateActionId}${
      params.toString() ? `?${params.toString()}` : ''
    }`;

    const response = await apiClient.put(url);
    
    // Vérification de la réponse
    if (response.status === 200) {
      return true;
    }
    
    return false;

  } catch (error) {
    
    // Gestion détaillée des erreurs
    let errorMessage = 'Erreur lors de la distribution';
    
    if (error.response) {
      const status = error.response.status;
      const data = error.response.data;
      
      switch (status) {
        case 400:
          errorMessage = data?.message || 'Requête invalide. Vérifiez les paramètres.';
          break;
        case 404:
          errorMessage = `Corporate Action ${corporateActionId} non trouvée.`;
          break;
        case 409:
          errorMessage = 'Conflit: La Corporate Action est déjà traitée.';
          break;
        case 500:
          errorMessage = 'Erreur interne du serveur.';
          break;
        default:
          errorMessage = `Erreur ${status}: ${data}`;
      }
    } else if (error.request) {
      errorMessage = 'Impossible de contacter le serveur. Vérifiez votre connexion.';
    } else {
      errorMessage = error.message || 'Erreur inattendue';
    }
    
    throw new Error(errorMessage);
  }
};


/**
 * Récupère la liste des CorporateAction en statut "Pending" pour un domaine donné.
 * @param {number} domainId 
 * @returns {Promise}
 */
export const getCorporateActionsPending = (domainId) =>
  apiClient.get(`api/CorporateAction/GetCorporateActionsPending/${domainId}`);
